module.exports = __webpack_public_path__ + "img/live-stage-console.88d0d4e2.jpg";